import { defineAction } from 'redux-define';

const ROOT = 'claro/BOOTING';
const CANCELLED = 'CANCELLED';
const ERROR = 'ERROR';
const PENDING = 'PENDING';
const SUCCESS = 'SUCCESS';

export const LOAD_NAV_DATA = defineAction(
  'LOAD_NAV_DATA',
  [CANCELLED, ERROR, PENDING, SUCCESS, 'BOOT'],
  ROOT,
);

export const SET_NAV_NODE = 'APP/nav/setNode';
export const SET_EXPIRENCE_TYPE = 'APP/nav/setExperienceType';
